import { useEffect } from "react";

const DisableInspect = () => {
  useEffect(() => {
    const handleKeyDown = (event) => {
      // Block F12
      if (event.key === "F12") {
        event.preventDefault();
      }

      // Block Ctrl + Shift + I / J / C
      if (
        event.ctrlKey &&
        event.shiftKey &&
        ["I", "J", "C"].includes(event.key.toUpperCase())
      ) {
        event.preventDefault();
      }

      // Block Ctrl + U (View Source)
      if (event.ctrlKey && event.key.toLowerCase() === "u") {
        event.preventDefault();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return null;
};

export default DisableInspect;
